"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWarningDto = instanceOfWarningDto;
exports.WarningDtoFromJSON = WarningDtoFromJSON;
exports.WarningDtoFromJSONTyped = WarningDtoFromJSONTyped;
exports.WarningDtoToJSON = WarningDtoToJSON;
exports.WarningDtoToJSONTyped = WarningDtoToJSONTyped;
const WarningType_1 = require("./WarningType");
/**
 * Check if a given object implements the WarningDto interface.
 */
function instanceOfWarningDto(value) {
    if (!('warningType' in value) || value['warningType'] === undefined)
        return false;
    if (!('warningMessage' in value) || value['warningMessage'] === undefined)
        return false;
    return true;
}
function WarningDtoFromJSON(json) {
    return WarningDtoFromJSONTyped(json, false);
}
function WarningDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warningType': (0, WarningType_1.WarningTypeFromJSON)(json['warningType']),
        'warningMessage': json['warningMessage'],
    };
}
function WarningDtoToJSON(json) {
    return WarningDtoToJSONTyped(json, false);
}
function WarningDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warningType': (0, WarningType_1.WarningTypeToJSON)(value['warningType']),
        'warningMessage': value['warningMessage'],
    };
}
//# sourceMappingURL=WarningDto.js.map